export const resistorColors = [
  { name: 'أسود', value: 0, color: '#000000' },
  { name: 'بني', value: 1, color: '#8B4513' },
  { name: 'أحمر', value: 2, color: '#FF0000' },
  { name: 'برتقالي', value: 3, color: '#FFA500' },
  { name: 'أصفر', value: 4, color: '#FFFF00' },
  { name: 'أخضر', value: 5, color: '#008000' },
  { name: 'أزرق', value: 6, color: '#0000FF' },
  { name: 'بنفسجي', value: 7, color: '#8B00FF' },
  { name: 'رمادي', value: 8, color: '#808080' },
  { name: 'أبيض', value: 9, color: '#FFFFFF' }
];

export const multiplierColors = [
  { name: 'أسود', value: 1, color: '#000000' },
  { name: 'بني', value: 10, color: '#8B4513' },
  { name: 'أحمر', value: 100, color: '#FF0000' },
  { name: 'برتقالي', value: 1000, color: '#FFA500' },
  { name: 'أصفر', value: 10000, color: '#FFFF00' },
  { name: 'أخضر', value: 100000, color: '#008000' },
  { name: 'أزرق', value: 1000000, color: '#0000FF' },
  { name: 'ذهبي', value: 0.1, color: '#FFD700' },
  { name: 'فضي', value: 0.01, color: '#C0C0C0' }
];

export const toleranceColors = [
  { name: 'بني', value: 1, color: '#8B4513' },
  { name: 'أحمر', value: 2, color: '#FF0000' },
  { name: 'ذهبي', value: 5, color: '#FFD700' },
  { name: 'فضي', value: 10, color: '#C0C0C0' }
];

export const temperatureCoefficient = [
  { name: 'بني', value: 100, color: '#8B4513' },
  { name: 'أحمر', value: 50, color: '#FF0000' },
  { name: 'برتقالي', value: 15, color: '#FFA500' },
  { name: 'أصفر', value: 25, color: '#FFFF00' }
];